import * as React from 'react';
import { ActivePane, useAppStateContext } from '../AppStateProvider/AppStateProvider';
import { ActivePaneToDisplay } from './Header';
import { Grid, makeStyles, Theme } from '@material-ui/core';
import classnames from 'classnames';
import { Popover } from 'n2p-ui-library';
import { useMemo } from 'react';
import { MenuButton } from '../../icons/MenuButton';

export const useStyles = makeStyles((theme: Theme) => ({
  headerBurgerMenu: {
    width: '60px',
    height: '50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    marginRight: '0px',
    '&hover': {
      backgroundColor: 'var(--color-primary-light-1)',
    },
  },
  headerContainer: {
    position: 'relative',
    marginLeft: 'auto',
    marginRight: '0px',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '5px',
  },
  headerBurgerMenuGeneral: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 'var(--spog-header-height)',
    color: 'var(--color-white)',
  },
  headerProfileMenu: {
    width: '200px',
    listStyle: 'none',
  },

  headerProfileMenuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '36px',
    padding: '0 0px',
  },
}));

export default function HeaderSmallItemMenu() {
  const classes = useStyles();
  const { dispatch } = useAppStateContext();

  function setActivePane({ pane, paneNumber }: { pane: ActivePane; paneNumber: number }) {
    return paneNumber === 1
      ? () =>
          dispatch({
            type: 'set-active-pane',
            newActivePane: ActivePane.CameraTest,
          })
      : () => dispatch({ type: 'set-active-pane', newActivePane: pane });
  }

  const renderAvatarComponent = useMemo((): JSX.Element => {
    return MenuButton();
  }, []);

  return (
    <div>
      <Grid>
        <div className={classes.headerBurgerMenuGeneral}>
          <div className={classnames(classes.headerContainer, classes.headerBurgerMenu)}>
            <Popover
              trigger="click"
              position="bottom"
              disableScroll
              offset={3}
              contentStyles={{
                animationName: 'fadeInUp',
                animationDuration: '.3s',
                borderRadius: 6,
                marginLeft: '15px',
                marginTop: '-3px',
                height: '195px',
              }}
              arrow={false}
              activatorControlled={renderAvatarComponent}
            >
              <ul className={classes.headerProfileMenu}>
                <li className={classes.headerProfileMenuItem} style={{ paddingTop: '15px' }}>
                  <button
                    type="button"
                    className="n2pc-btn-text"
                    style={{ marginLeft: '10px' }}
                    onClick={setActivePane({
                      pane: ActivePaneToDisplay[ActivePane.DeviceCheck].pane,
                      paneNumber: ActivePaneToDisplay[ActivePane.DeviceCheck].paneNumber,
                    })}
                  >
                    {ActivePaneToDisplay[ActivePane.DeviceCheck].label}
                  </button>
                </li>
                <li className={classes.headerProfileMenuItem} style={{ paddingTop: '15px' }}>
                  <button
                    type="button"
                    className="n2pc-btn-text"
                    style={{ marginLeft: '10px' }}
                    onClick={setActivePane({
                      pane: ActivePaneToDisplay[ActivePane.Connectivity].pane,
                      paneNumber: ActivePaneToDisplay[ActivePane.Connectivity].paneNumber,
                    })}
                  >
                    {ActivePaneToDisplay[ActivePane.Connectivity].label}
                  </button>
                </li>
                <li className={classes.headerProfileMenuItem} style={{ paddingTop: '15px' }}>
                  <button
                    type="button"
                    className="n2pc-btn-text"
                    style={{ marginLeft: '10px' }}
                    onClick={setActivePane({
                      pane: ActivePaneToDisplay[ActivePane.CodecsTest].pane,
                      paneNumber: ActivePaneToDisplay[ActivePane.CodecsTest].paneNumber,
                    })}
                  >
                    {ActivePaneToDisplay[ActivePane.CodecsTest].label}
                  </button>
                </li>
                <li className={classes.headerProfileMenuItem} style={{ paddingTop: '15px' }}>
                  <button
                    type="button"
                    className="n2pc-btn-text"
                    style={{ marginLeft: '10px' }}
                    onClick={setActivePane({
                      pane: ActivePaneToDisplay[ActivePane.Quality].pane,
                      paneNumber: ActivePaneToDisplay[ActivePane.Quality].paneNumber,
                    })}
                  >
                    {ActivePaneToDisplay[ActivePane.Quality].label}
                  </button>
                </li>
                <li className={classes.headerProfileMenuItem} style={{ paddingTop: '15px' }}>
                  <button
                    type="button"
                    className="n2pc-btn-text"
                    style={{ marginLeft: '10px' }}
                    onClick={setActivePane({
                      pane: ActivePaneToDisplay[ActivePane.Results].pane,
                      paneNumber: ActivePaneToDisplay[ActivePane.Results].paneNumber,
                    })}
                  >
                    {ActivePaneToDisplay[ActivePane.Results].label}
                  </button>
                </li>
              </ul>
            </Popover>
          </div>
        </div>
      </Grid>
    </div>
  );
}
